<div class="stepper-wrapper">
  @for (lbl of labels; track lbl; let i = $index) {
    <div
      class="stepper-item"
      [class.active]="i <= valueIndex">
      <div class="step-counter">{{ i + 1 }}</div>
      <div class="step-name">{{ lbl }}</div>
    </div>
  }
</div>
